export default {"src":"/_next/static/media/arrow-down-yellow.cad412a6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};